import {useEffect, useState} from 'react';
import type {RechargeWebWeekCardConfig} from '@fe-progressive/package-progressive/recharge-web';
import {
  getMultiple,
  getVipWeekCardConfigList,
} from './recharge-tab/recharge-tab.service';

export function useRechargeWebRulePanelData(): {
  waterMultiplier: number;
  weekCardConfigs: RechargeWebWeekCardConfig[];
} {
  const [waterMultiplier, setWaterMultiplier] = useState(5);
  const [weekCardConfigs, setWeekCardConfigs] = useState<
    RechargeWebWeekCardConfig[]
  >([]);

  useEffect(() => {
    let cancelled = false;
    getMultiple()
      .then(m => {
        if (!cancelled && typeof m === 'number') {
          setWaterMultiplier(m);
        }
      })
      .catch(() => {
        /* 保持默认倍数 */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    getVipWeekCardConfigList()
      .then(list => {
        if (!cancelled && Array.isArray(list)) {
          setWeekCardConfigs(list);
        }
      })
      .catch(() => {
        /* 周卡表空态 */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return {waterMultiplier, weekCardConfigs};
}
